import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PaymentPlanTwoFactorAuthenticationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PaymentPlanTwoFactorAuthenticationError', ...args);
    }
}
export default PaymentPlanTwoFactorAuthenticationError;
